import { Components, Theme } from '@mui/material/styles';

export const dividerTheme: Components<Theme>['MuiDivider'] = {
  // styleOverrides: {},
  // variants: [],
};
